// Module
var code = "<span data-bind=\"html: html, style: { opacity: opacity }\"></span>\r\n<div class=\"loader-wrapper\" style=\"top: 50%; left: 50%; transform: translate(-50%, -50%);\" data-bind=\"visible: isLoading\">\r\n    <div class=\"loader\"></div>\r\n</div>";
// Exports
export default code;